export function formatDataAutomationId(dataAutomationId: string, prefix = "", suffix = ""): string{
    return prefix + dataAutomationId?.replace(/\s/g, "-").toLowerCase() + suffix;
}